module.exports = __webpack_public_path__ + "assets/img/功能介绍-同顺模式.2e007e1a.png";